import Vue from 'vue';

Vue.filter('imgParse', (value, w, h) => {
  w = w !== undefined ? w : 173;
  h = h !== undefined ? h : 219;
  if (value) {
    try {
      const list = JSON.parse(value);

      if (list.length > 0) {
        let img = list[0].replace("http://sha-oss-static.oss-cn-shanghai.aliyuncs.com/", "http://image2.intramirror.com/")
          .replace("http://image.intramirror.com/", "http://image2.intramirror.com/")
          .replace("http://static-intramirror.oss-cn-hongkong.aliyuncs.com/", "http://image2.intramirror.com/");
        return img + "?x-oss-process=image/resize,m_pad,w_" + w + ",h_" + h + ",limit_0/auto-orient,0/quality,q_100";
      } else {
        return "";
      }
    } catch (e) {
      console.log(e);
      return "";
    }
  } else {
    return ""
  }
})
